var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 12,
    viewBox: "0 0 54 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM53.5303 6.53033C53.8232 6.23744 53.8232 5.76256 53.5303 5.46967L48.7574 0.696699C48.4645 0.403806 47.9896 0.403806 47.6967 0.696699C47.4038 0.989593 47.4038 1.46447 47.6967 1.75736L51.9393 6L47.6967 10.2426C47.4038 10.5355 47.4038 11.0104 47.6967 11.3033C47.9896 11.5962 48.4645 11.5962 48.7574 11.3033L53.5303 6.53033ZM1 6.75H53V5.25H1V6.75Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenarrow);
export default __webpack_public_path__ + "static/media/greenarrow.115f2681d15a8764aa410890a74393a4.svg";
export { ForwardRef as ReactComponent };